import { Check } from 'lucide-react';
import type { Step } from './bookingFlow';

const STEPS: { key: Step; label: string }[] = [
  { key: 'experience', label: 'Experience' },
  { key: 'option', label: 'Package' },
  { key: 'dateGuests', label: 'Date' },
  { key: 'contact', label: 'Details' },
  { key: 'review', label: 'Confirm' },
];

/** Compact categorised progress bar across the booking steps. */
export function WizardSteps({ step }: { step: Step }) {
  const activeIndex =
    step === 'success' ? STEPS.length : STEPS.findIndex((s) => s.key === step);

  return (
    <ol className="flex items-center">
      {STEPS.map((s, i) => {
        const done = i < activeIndex;
        const active = i === activeIndex;
        return (
          <li key={s.key} className="flex flex-1 items-center last:flex-none">
            <div className="flex items-center gap-1.5">
              <span
                className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full font-sans text-[0.6rem] font-semibold ${
                  done
                    ? 'bg-crimson text-white'
                    : active
                      ? 'border border-crimson text-crimson'
                      : 'border border-charcoal/20 text-charcoal/40'
                }`}
              >
                {done ? <Check className="h-3 w-3" strokeWidth={3} /> : i + 1}
              </span>
              <span
                className={`hidden font-sans text-[0.6rem] font-medium uppercase tracking-wide2 sm:inline ${
                  active
                    ? 'text-crimson'
                    : done
                      ? 'text-charcoal/70'
                      : 'text-charcoal/35'
                }`}
              >
                {s.label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <span
                className={`mx-2 h-px flex-1 ${done ? 'bg-crimson/40' : 'bg-charcoal/15'}`}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
